import '../input-action';

describe('input-action', () => {
  it('Expect custom element <input-action> is defined', () => {
    expect(customElements.get('input-action')).toBeDefined();
  });
});
